import { RouteConfig } from 'vue-router';

import { Errors } from '@/enums/errors.enum';
import store from '@/store/store';
import { getReportGroups } from '@/utils/report';

export const procedureReportGroupsRoute: RouteConfig = {
  path: 'reports/groups',
  name: 'procedureReportGroups',
  component: () =>
    import(/* webpackChunkName: "ProcedureReports" */ '@/views/mainRoute/procedure/details/ReportGroups.vue'),
  beforeEnter: (to, from, next) => {
    getReportGroups(to)
      .then(() => next())
      .catch(err => store.dispatch('notifyError', { title: Errors.REPORT_CANNOT_GET }));
  }
};
